<template lang="pug">
    v-form(autocomplete='false' v-model='formulario_validado')
      v-col
        v-autocomplete(:rules='[Rules.required]' label='Cliente' v-model='Datos.cliente_denominacion' :items='clientsRecord' :item-text='item => `${item.document} - ${item.name} `' item-value='name' )
        v-layout.row.wrap
          v-flex.px-2
            span.grey--text.text--grey( v-html='Datos.cliente_email||"Sin correo registrado"' ) 
          v-flex.px-2
            v-autocomplete(:rules='[Rules.required]' label='Dirección' v-model='Datos.cliente_direccion' :items='Datos.lista_de_direcciones' item-text='ubicación' item-value='ubicación')
</template>
<script>
import {mapState, mapGetters} from 'vuex'
import {obtener_llave} from '@/Helper'
export default {
  data: ()=>({
    formulario_validado: false
  }),
  props:{
    modelo: String
  },
  watch:{
 
    'Datos.cliente_denominacion'(){

      let {cliente_denominacion } = this.Datos
      let registro = this.clientsRecord.filter(item => item.name == cliente_denominacion)[0]
      if (!registro ) return
      this.Datos.cliente_tipo_de_documento =  registro.documenType.code || ''
      this.Datos.cliente_email = registro.email || ''
      this.Datos.cliente_numero_de_documento = registro.document || ''
      this.Datos.lista_de_direcciones = registro.direcciones || ''
      this.Datos.cliente_direccion = registro.ubicación || ''
    },
    'Datos.cliente_direccion'(){
      let { cliente_direccion } = this.Datos
      if ( !cliente_direccion) return

      this.Datos.punto_de_llegada_direccion = cliente_direccion
      this.Datos.punto_de_llegada_ubigeo =  lista_de_direcciones.filter(item => item.ubicación == this.Datos.punto_de_llegada_direccion)[0].ubigeo
    },
  
  },
  computed:{
    Modelo() { return this.$store.state[this.modelo] },
    Datos() { return this.$store.state[this.modelo].data },
    Rules() { return this.$store.state.Helpers.rules},
    ...mapGetters({
      clientsRecord: 'Clients/record',
      
    })
  },
}
</script>
